import { BigButton } from "..";

export const EditPopupButtonsUI = ({
  cancelText = 'Cancel',
  submitText = 'Save',
  loading,
  onCacel,
  buttonStyle = {},
  style = {},
  hideCancelButton = false,
}) => {
  return (
    <div
      className="d-flex align-stretch justify-content-between gap-3"
      style={{
        position: 'absolute',
        padding: '1.5rem',
        width: '100%',
        left: '0',
        bottom: '0',
        background: '#fff',
        zIndex: '99',
        borderTop: '1px solid var(--neutral20-color)',
        ...style,
      }}>
      {!hideCancelButton ? (
        <BigButton
          className="bigButton lf-btn-3 w-100"
          buttonTitle={cancelText}
          onClick={onCacel}
          style={buttonStyle}
        />
      ) : null}
      <BigButton
        type="submit"
        disabled={loading}
        className="bigButton lf-btn-1 w-100"
        buttonTitle={submitText}
        isLoading={loading}
        style={buttonStyle}
      />
    </div>
  );
};
